import { render, staticRenderFns } from "./InformActivity.vue?vue&type=template&id=a060e9c0&"
import script from "./InformActivity.vue?vue&type=script&lang=js&"
export * from "./InformActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports